<!-- Revendo Iframe → GTM Bridge -->
(function() {
  window.dataLayer = window.dataLayer || [];

  window.addEventListener('message', function(e) {
    // Allow staging and production
    var validOrigins = ['purchase.revendo.ch'];
    var isValid = validOrigins.some(function(origin) {
      return e.origin.indexOf(origin) !== -1;
    });
    if (!isValid) return;
    if (!e.data || !e.data.type) return;

    var d = e.data;

    switch(d.type) {
      case 'revendo_device_selected':
        dataLayer.push({
          event: 'sale_add_to_cart',
          ecommerce: {
            currency: 'CHF',
            value: (d.details && d.details.price) ? d.details.price.selected : 0,
            items: [{
              item_name: (d.details && d.details.product) ? d.details.product.name : 'Device',
              price: (d.details && d.details.price) ? d.details.price.selected : 0
            }]
          }
        });
        console.log('📊 dataLayer: sale_add_to_cart', d.details);
        break;

      case 'revendo_form_start':
        dataLayer.push({
          event: 'form_start',
          form_identifier: d.form_identifier || 'product_assessment_form'
        });
        console.log('📊 dataLayer: form_start');
        break;

      case 'revendo_order_complete':
        dataLayer.push({
          event: 'sale_completed',
          ecommerce: {
            transaction_id: String(d.order_id),
            value: d.total,
            currency: 'CHF',
            items: [{
              item_name: 'Trade-in',
              quantity: d.items_count
            }]
          }
        });
        console.log('📊 dataLayer: sale_completed', d);
        break;
    }
  });
})();
